import { render, staticRenderFns } from "./index3.vue?vue&type=template&id=af344244&scoped=true"
import script from "./index3.vue?vue&type=script&lang=js"
export * from "./index3.vue?vue&type=script&lang=js"
import style0 from "./index3.vue?vue&type=style&index=0&id=af344244&prod&lang=scss"
import style1 from "./index3.vue?vue&type=style&index=1&id=af344244&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af344244",
  null
  
)

export default component.exports